import React from 'react'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactElement
  offset?: [number, number]
  arrowXOffset?: number
  title: React.ReactNode
}

export const CustomizableTooltip = React.forwardRef<HTMLElement, CustomTooltipProps>(({ children, title, offset = [0, -6], arrowXOffset, ...props }, _ref) => {
  // Don't render tooltip if title is null or undefined
  if (!title) {
    return children
  }

  return (
    <Tooltip
      title={title}
      slotProps={{
        popper: {
          modifiers: [{ name: 'offset', options: { offset } }],
          slotProps: {
            root: {
              className: '!mx-4',
            },
          },
        },
        tooltip: {
          className:
            'flex items-center min-h-[40px] min-w-fit px-3 py-1.5 !bg-white !rounded-lg !text-brand-neutral-800 !font-sans border border-brand-neutral-200 shadow-[0_0.6px_25px_0_rgba(0,0,0,0.10),0_10px_10px_0_rgba(0,0,0,0.04)]',
        },
        arrow: {
          className: '!text-white [&::before]:border [&::before]:border-brand-neutral-200',
          sx: arrowXOffset ? { left: `${arrowXOffset}px !important` } : undefined,
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  )
})

export default CustomizableTooltip
